import { Link, useLocation } from 'react-router';
import { WhatsNew } from '../screens/Blog.tsx';
import { wayRound } from '../publicPages.ts';

/**
 * The foot of every page of the portal once signed in (design study 30, A; Jason, 2026-10-28: "we should have links
 * to some of these things somewhere sensible?"): a rule, the latest release in a line, then About the portal, Privacy
 * and Terms, the same for NSB and a client. Held to the window's foot on a short page (Layout is a column), under the
 * page on a long one, its own room below for the Feedback button kept at the window's foot. On a phone the release
 * has its line and the three pages go under it.
 */
export function PortalFoot() {
  const { pathname } = useLocation();
  return (
    <footer className="shell mt-auto pb-28">
      <nav aria-label="About the portal" className="flex flex-wrap items-baseline gap-x-6 gap-y-3 border-t border-rule pt-5 text-sm">
        <WhatsNew className="basis-full sm:mr-auto sm:basis-auto" />
        {wayRound(pathname, 'in the portal').map(([to, words]) => (
          <Link key={to} to={to} className="link">
            {words}
          </Link>
        ))}
      </nav>
    </footer>
  );
}
